exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1OcxX0OBVsrcn0{cursor:pointer}._1OcxX0OBVsrcn0[disabled]{color:#6b778c;cursor:not-allowed}._3EgGl1uanPg9yw{display:flex;align-items:center}._3-oEQswwlt93Rr{margin:0 -12px}._9eIvwQ7fQqnjED{flex:0 0 auto;margin-right:8px}.iJqUmAxuUQPxqp{box-sizing:border-box;display:block;flex:1 1 auto;padding-right:32px;width:100%;word-wrap:break-word}", ""]);

// exports
exports.locals = {
	"oneTimeMessageDismissedButton": "_1OcxX0OBVsrcn0",
	"oneTimeMessageDismissedButtonInner": "_3EgGl1uanPg9yw",
	"popoverMenu": "_3-oEQswwlt93Rr",
	"iconWrapper": "_9eIvwQ7fQqnjED",
	"message": "iJqUmAxuUQPxqp"
};